import { dataLayer } from '../lib/data-layer';

export function pushSearchEvent(term: string) {
  dataLayer({
    event: 'search',
    search_term: term,
  });
}
